import { StorageManager } from '../../../../common/storage-manager.class';
import { environment } from '../../../../../environments/environment';

export class CamposEnvironmentDefinition {
    public serverURL = environment.serverUrl;
    public appName = environment.appName;
    public parcelaName = environment.features.parcelaName;
    public parcelasName = environment.features.parcelasName;
    public showMapas = environment.features.showMapas;
    public uds_medida = StorageManager.getUser().uds_medida;
    public rol = StorageManager.getUser().rol;
    public hasClients = environment.features.hasClients;
    public cliente = StorageManager.getClient();
    public usuario = StorageManager.getUser();
    public showTareasMto = environment.features.showTareasMto;
}// class;